import { FC } from 'react';
import { Col, Form, Input, Row } from 'antd';
import { Button, Text } from '@quinyx/ui';

import { emailRegExp } from '../validation';
import Section from '../../components/Section';
import { useTranslate } from '../../hooks/translate';

interface IAdminFormProps {
  onSubmit: ({ email }: { email: string }) => void;
  isLoading: boolean;
  buttonText: string;
  formTitle: string;
  formDescription?: string;
}

const AdminForm: FC<IAdminFormProps> = ({
  onSubmit,
  isLoading,
  buttonText,
  formTitle,
  formDescription,
}) => {
  const { t } = useTranslate();

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Row gutter={[16, 32]}>
        <Col xs={24} md={16} lg={12} xl={8} xxl={6}>
          <Section title={formTitle}>
            {formDescription && (
              <Text variant="smallRegular" color="SurfaceOnSurfaceAlt">
                {formDescription}
              </Text>
            )}
            <Form.Item
              label={t('form.email')}
              name="email"
              rules={[
                { required: true },
                {
                  pattern: emailRegExp,
                  message: t('form.emailInvalid'),
                },
              ]}>
              <Input />
            </Form.Item>
          </Section>
        </Col>
        <Col span={24}>
          <Button
            type="submit"
            data-test-id="update-admin-button"
            text={buttonText}
            isLoading={isLoading}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AdminForm;
